import { render, staticRenderFns } from "./IncrementalOnboardingHeader.vue?vue&type=template&id=473c6b14&"
import script from "./IncrementalOnboardingHeader.vue?vue&type=script&lang=js&"
export * from "./IncrementalOnboardingHeader.vue?vue&type=script&lang=js&"
import style0 from "./IncrementalOnboardingHeader.vue?vue&type=style&index=0&id=473c6b14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports